import script from "./BadgeToast.vue?vue&type=script&setup=true&lang=ts"
export * from "./BadgeToast.vue?vue&type=script&setup=true&lang=ts"

import "./BadgeToast.vue?vue&type=style&index=0&id=10844d00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10844d00"]])

export default __exports__